export default "/images/965887a6847a2e4b81d392b8c007cbae.avif";